/** Enrich the existing article graph using the same Shopify data as the page.
 * App embeds remain enabled. No content_for_header parsing, network or invented
 * author/date. Keep one page entity even if a provider inserts its graph late.
 */
export function reconcileArticle(document) {
  const source = document.querySelector('[data-tbwl-article-source]');
  if (!source) return;
  let article;
  try { article = JSON.parse(source.textContent); } catch { return; }
  if (!article.headline || !article.author || !article.datePublished) return;
  const canonical = document.querySelector('link[rel="canonical"]')?.href;
  if (!canonical) return;
  // SEOOn owns the public byline independently of Shopify's legacy author field.
  // Match the actual displayed author; never infer authorship from quotations.
  const byline = document.querySelector('.Avada-Author-Info__name');
  const visibleAuthor = byline?.textContent?.trim();
  if (visibleAuthor) article.author = { '@type': 'Person', name: visibleAuthor };
  else if (!document.querySelector('[data-tbwl-article-byline]')) {
    const details = document.querySelector('.blog-post-details');
    if (details) {
      const author = document.createElement('span');
      author.setAttribute('data-tbwl-article-byline', '');
      author.textContent = article.author.name;
      details.append(author);
    }
  }
  if (visibleAuthor) document.querySelector('[data-tbwl-article-byline]')?.remove();
  article['@context'] = 'https://schema.org';
  article['@id'] = `${canonical}#article`;
  article.url = canonical;
  article.mainEntityOfPage = { '@type': 'WebPage', '@id': canonical };
  const matches = [];
  for (const node of document.querySelectorAll('script[type="application/ld+json"]')) {
    let data;
    try { data = JSON.parse(node.textContent); } catch { continue; }
    if (['Article', 'NewsArticle', 'BlogPosting'].includes(data['@type']) && data.headline === article.headline) matches.push(node);
  }
  const target = matches.shift() || document.createElement('script');
  target.type = 'application/ld+json';
  target.setAttribute('data-tbwl-article-schema', '');
  const serialized = JSON.stringify(article);
  if (target.textContent !== serialized) target.textContent = serialized;
  if (!target.parentNode) source.after(target);
  for (const duplicate of matches) duplicate.remove();
}

if (typeof document !== 'undefined') {
  reconcileArticle(document);
  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches?.('script[type="application/ld+json"], .Avada-Author-Info__name') || node.querySelector?.('script[type="application/ld+json"], .Avada-Author-Info__name'))
    ))) reconcileArticle(document);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}
